import * as yup from "yup";

export const employeeTypeSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
